import { Component, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../../../base-modal.component';
import { ModalComponent } from '../../../../modal/modal.component';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'edit-image-modal',
    templateUrl: 'editImageModal.component.html',
    standalone: false
})
export class EditImageModalComponent extends BaseModalPageComponent {
  constructor(public selfModal: ModalComponent, location: Location) {
    super(location);
  }

  public inputImage = null;
  public outputImage: any = null;
  public undoTrigger = new Subject<any>();

  public init(data: any) {
    this.inputImage = {
      image: data,
      config: {
        rotate: 0,
        crop: null
      }
    };
  }

  getOutput(outputConfig) {
    this.outputImage = outputConfig;
  }

  apply() {
    this.selfModal.close(this.outputImage);
  }

  reset() {
    this.undoTrigger.next(true);
    this.selfModal.close();
  }
}
